import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { Alert, Button } from "react-bootstrap";
import FormRenderer, { ComponentMapper, componentTypes, FormTemplate } from "./FormRenderer";
import PageLoader from "../shared/PageLoader";
import { ERROR_MESSAGES } from "../../utils/constants";
import { download, preventDefault, readBlobAsJson } from "../../utils/common";

interface BaseImportModalProps {
    onClose: any;
    importSchema: any;
    importFunction: any;
    title: string;
    successMessage?: string;
}

function BaseImportModal({ onClose, importSchema, importFunction, title, successMessage }: BaseImportModalProps) {
    const [apiError, setApiError] = useState<any>(null)

    const { uploadFile, uploading } = importFunction(async (response: any) => {
        if (response instanceof AxiosError) {
            const contentType = response.response && response.response.headers['content-type'] || "";
            if (contentType.includes('application/json')) {
                const errorJson = await readBlobAsJson((response.response || {}).data || {});
                let errors = (errorJson || {}).errors || [ERROR_MESSAGES.DEFAULT];
                toast.error(errors.join(', '));
            }
        } else {
            const contentType = response && response.headers['content-type'] || "";
            if (contentType.includes('application/json')) {
                const successJson = await readBlobAsJson((response || {}).data || {});
                let message = (successJson || {}).message;
                toast.success(message || successMessage || 'File uploaded successfully.');
                onClose();
            } else {
                setApiError(response);
            }
        }
    },
    async (response: any) => {
        if (response instanceof AxiosError) {
            const contentType = response.response && response.response.headers['content-type'] || "";
            if (contentType.includes('application/json')) {
                const errorJson = await readBlobAsJson((response.response || {}).data || {});
                let errors = (errorJson || {}).errors || [ERROR_MESSAGES.DEFAULT];
                toast.error(errors.join(', '));
            }
        }
    });

    function downloadErros(e: any) {
        preventDefault(e);
        const data = apiError.data;
        const blob = new Blob([data], { type: apiError.headers['content-type'] })
        const URL = window.URL || window.webkitURL;
        const downloadUrl = URL.createObjectURL(blob);
        download('Errors.xlsx', downloadUrl);
    }

    function handleSubmit({ file }: any) {
        setApiError(null);
        const formData = new FormData();
        const files = [...file.inputFiles];
        files.forEach(_file => {
            formData.append('file', _file, _file.name);
        });
        uploadFile(formData);
    }

    return (
        <>
            <Modal show={true} backdrop="static" animation={false} size="lg" dialogClassName="" centered={true}>
                <Modal.Header closeButton={true} onHide={onClose}>
                    <Modal.Title className="bg">{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex flex-column" style={{ minHeight: '200px' }}>
                        {
                            Boolean(apiError) &&
                            <Alert variant="danger" className="mx-4 my-2">
                                There are few errors identified in the file uploaded. Correct the errors and upload again. <a href="/" onClick={downloadErros}>Click here</a> to download the errors.
                            </Alert>
                        }
                        <div className="d-flex flex-column col-8 mx-auto">
                            <FormRenderer FormTemplate={FormTemplate}
                                componentMapper={ComponentMapper}
                                schema={importSchema}
                                onSubmit={handleSubmit}
                            />
                        </div>

                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-end">
                    <Button variant="secondary" onClick={onClose} >Close</Button>
                </Modal.Footer>
            </Modal>
            {
                uploading && <PageLoader>Uploading...</PageLoader>
            }
        </>
    )
}

export default BaseImportModal;